import { Grid } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { RootState } from "../../../store"
import { FileState, FilesListState } from "../../../store/actions/file"
import ScrollHint from "../../common/scroll-hint"
import NoData from "../../error/nodata"
import FileCard from "../card"

const FileList = () => {
	const { t } = useTranslation()
	const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
	const distinteState: FilesListState = useSelector(
		(state: RootState) => state.files
	)

	return (
		<>
			<Grid container flexWrap={"wrap"} alignContent={"space-between"}>
				{distinteState?.list?.page?.content.map((currentFile: FileState) => {
					return (
						<FileCard
							key={currentFile?.id}
							fileInfo={currentFile}
							userTimeZone={userTimeZone}
						/>
					)
				})}
				{distinteState?.list?.page?.content?.length === 0 && <NoData />}
			</Grid>
			{distinteState?.list?.nextUrl ? (
				<ScrollHint />
			) : (
				<div style={{ textAlign: "center" }}>
					{t("endScroll", { ns: "distinte" })}
				</div>
			)}
		</>
	)
}

export default FileList
